import { render } from "./GameConfig.vue?vue&type=template&id=674a5b48&scoped=true"
import script from "./GameConfig.vue?vue&type=script&lang=js"
export * from "./GameConfig.vue?vue&type=script&lang=js"

import "./GameConfig.vue?vue&type=style&index=0&id=674a5b48&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674a5b48"]])

export default __exports__